import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TramiteStepperService {
  private stepCurrent$ = new BehaviorSubject<number>(0);

  get stepCurrent(): Observable<number> {
    return this.stepCurrent$.asObservable();
  }

  setStepCurrent(value: number) {
    this.stepCurrent$.next(value);
  }

  clearStepCurrent(): void {
    this.stepCurrent$.complete();
    this.stepCurrent$ = new BehaviorSubject<number>(0);
  }
}
